<template>
  <div>
    <el-table :data="rows" :empty-text="emptyText" border>
      <!--序号-->
      <el-table-column :label="$t('operationCenter.ind')" align="center" width="60px">
        <template slot-scope="scope">
          <span>{{ (pageNumber - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!--订单号-->
      <el-table-column
        :label="$t('orderCenterCont.TheOrderNumber')"
        :show-overflow-tooltip="true"
        align="left"
        min-width="160"
        prop="orderNumber"
      >
        <template slot-scope="scope">
          <div>
            <el-popover placement="top" popper-class="copy" trigger="hover">
              <el-button
                style="color: black; font-size: 12px; padding: 2px"
                type="text"
                @click="copy(scope.row.orderNumber)"
              >
                {{ $t('orderDetails.copy') }}
              </el-button>
              <div slot="reference" class="is-click-column" @click="$emit('detail', scope.row)">
                {{ scope.row.orderNumber }}
              </div>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('orderLogAddress.result')" min-width="170">
        <template slot-scope="scope">
          <el-tag :type="tagType(scope.row.receiveAddressCheckResult)">
            {{ resultLabel(scope.row.receiveAddressCheckResult) }}
          </el-tag>
        </template>
      </el-table-column>
      <!--运单号-->
      <el-table-column
        :label="$t('newOrder.waybillNumber')"
        :show-overflow-tooltip="true"
        align="left"
        min-width="160"
        prop="waybillNumber"
      >
        <template slot-scope="scope">
          <div>
            <el-popover placement="top" popper-class="copy" trigger="hover">
              <el-button
                style="color: black; font-size: 12px; padding: 2px"
                type="text"
                @click="copy(scope.row.waybillNumber)"
              >
                {{ $t('orderDetails.copy') }}
              </el-button>
              <div slot="reference">
                {{ scope.row.waybillNumber }}
              </div>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <!--服务商单号-->
      <el-table-column
        :label="$t('GlobalSetObj.serviceLogistics')"
        min-width="160"
        prop="logisticsNumber"
      >
        <template slot-scope="scope">
          <div>
            <el-popover placement="top" popper-class="copy" trigger="hover">
              <el-button
                style="color: black; font-size: 12px; padding: 2px"
                type="text"
                @click="copy(scope.row.logisticsNumber)"
              >
                {{ $t('orderDetails.copy') }}
              </el-button>
              <div slot="reference">
                {{ scope.row.logisticsNumber }}
              </div>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <!--客户-->
      <el-table-column
        :label="$t('operationCenter.client')"
        :show-overflow-tooltip="true"
        align="left"
        min-width="160"
        prop="customerName"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.customerName }}</div>
        </template>
      </el-table-column>
      <!--客户单号-->
      <el-table-column
        :label="$t('placeOrder.customerNumber')"
        :show-overflow-tooltip="true"
        align="left"
        min-width="160"
        prop="customerNumber"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.customerNumber }}</div>
        </template>
      </el-table-column>
      <!-- 发件邮编 -->
      <el-table-column
        :label="$t('uploadFile.senderPostalCode')"
        min-width="150"
        prop="senderZipcode"
      />
      <!-- 收件州 -->
      <el-table-column
        :label="$t('collectionCenter.receivingState')"
        min-width="150"
        prop="receiveState"
      />
      <!-- 收件城市 -->
      <el-table-column
        :label="$t('collectionCenter.receivingCity')"
        min-width="150"
        prop="receiveCity"
      />
      <!-- 收件邮编 -->
      <el-table-column
        :label="$t('uploadFile.recipientPostalCode')"
        min-width="150"
        prop="receiveZipcode"
      />
      <!--是否成功-->
      <el-table-column
        :label="$t('orderCenterCont.WhetherSuccessful')"
        :show-overflow-tooltip="true"
        align="center"
        min-width="120"
        prop="state"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state === states.FAILURE" type="danger">
            {{ $t('operationCenter.fail') }}
          </el-tag>
          <el-tag v-if="scope.row.state === states.SUCCESS" type="success">
            {{ $t('operationCenter.succeed') }}
          </el-tag>
        </template>
      </el-table-column>
      <!--失败原因-->
      <el-table-column :label="$t('GlobalSetObj.ReasonForFailure')" prop="failureMessage" />
      <el-table-column
        :label="$t('orderCenterCont.CreationTime')"
        :show-overflow-tooltip="true"
        align="left"
        min-width="180"
        prop="createTime"
      />
      <!--安骏报文-->
      <el-table-column
        :label="$t('orderCenterCont.AnjunDatagram')"
        :show-overflow-tooltip="false"
        align="left"
        min-width="200"
        prop="dealedRequestParams"
      >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <pre slot="content" style="max-height: 400px; overflow: auto">
                  {{ scope.row.responseParams }}
                </pre>
            <div class="paramsStyle">{{ scope.row.responseParams }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--客户报文-->
      <el-table-column
        :label="$t('orderCenterCont.CustomerDatagram')"
        :show-overflow-tooltip="false"
        align="left"
        min-width="200"
        prop="requestParams"
      >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <pre slot="content" style="max-height: 400px; overflow: auto">
                  {{ scope.row.requestParams }}
                </pre>
            <div class="paramsStyle">{{ scope.row.requestParams }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column :label="$t('orderCenterCont.operation')" fixed="right" width="140">
        <template slot-scope="scope">
          <el-button type="text" @click="$emit('detail', scope.row)">{{ $t('orderCenterCont.ViewDetails') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { copyData } from '@/utils/copyData';
import { addressCheckLabel, addressCheckTagType, ORDER_LOG_STATE } from './orderLogQuery';
export default {
  name: 'OrderLogTable',
  props: {
    rows: { type: Array, default: () => [] },
    pageNumber: { type: Number, required: true },
    pageSize: { type: Number, required: true },
    emptyText: { type: String, required: true }
  },
  data: () => ({ states: ORDER_LOG_STATE }),
  methods: {
    copy: copyData,
    tagType: addressCheckTagType,
    resultLabel(value) { return addressCheckLabel(value, (key) => this.$t(key)); }
  }
};
</script>
<style scoped>
.paramsStyle { width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
</style>
